import { axiosService } from "./axiosService";

const inventoryApi = {
    getByMonth(params) {
        const url = `/inventory`;
        return axiosService.get(url, { params })
    },
    createInventory(body) {
        const url = '/inventory';
        return axiosService.post(url, body)
    },
    getMonthlyExport() {
        const url = '/monthly-export';
        return axiosService.get(url)  
    },
}

export default inventoryApi;